
































































































// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";
import {Mixins} from 'vue-mixin-decorator';

// Components
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import GroupButton, {
  GroupButtonPredefinedStyle
} from "@/shared/components/group-button.component.vue";
import Field from "@/shared/components/field.component.vue";
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';

// Constants
import Assets from "@/constants/assets.ts";
import Constans from "@/constants/constants.ts";

// Models
import { SaleInfo } from "@/clickbuy/purchase/models/sale-info.model";

// Services
import { ConvocationService } from "@/manager/convocation/convocation.service";
import BillingService from '@/manager/billing/billing.service';

// Filters
import pluralizeFilter from "@/shared/filters/pluralize.filter.ts";

//Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';


interface MixinInterface extends NotificationMessage, ErrorMixin, Vue {
}

@Component({
  components: {
    Icon,
    GroupButton,
    Field,
    SpotlightText
  },
  computed: {
    ...mapGetters({
      getPurchase: 'getPurchase',
      saleInfoList: "getSaleInfoList",
      saleInfoDefault: "getSaleInfoDefault",
      getConvocation: "getConvocation",
      getSaleInfo: "getSaleInfo",
      currentPurchase: 'getCurrentPurchase',
    })
  },
  filters: {
    pluralizeFilter
  }
})

export default class ConvocationInfo extends Mixins<MixinInterface>(
    NotificationMessage,
    ErrorMixin,
) {
  @Prop({ default: false }) private showConvocation!: boolean;
  @Prop() private convocationId!: string;
  @Prop() private purchase!: any;
  @Prop() private priceApplied!: number;

  private assets = Assets;
  private iconEnum = IconEnum;
  private saleInfoList!: SaleInfo[];
  private getSaleInfo!: any;
  private saleInfoDefault!: any;
  private getConvocation!: any;
  private convocationSelected: SaleInfo = new SaleInfo();
  private groupButtonPredefinedStyle = GroupButtonPredefinedStyle;
  private convocationOptions: any[] = [];
  private convocationOptionSelected = null;
  private convocationInfoLoaded = false;
  private convocationService = ConvocationService;
  private error = "";
  private getPurchase:any;

  @Watch("convocationOptionSelected")
  private watchConvocationOptionSelected(newVal: any, oldVal: any) {
    if (newVal !== (this.convocationSelected.product as any).id) {
      this.setConvocationSelected(this.getSaleInfo(newVal));
    }
  }

  private sendChangeDataBillEmail() {
    BillingService.sendChangeDataBillEmail(this.purchase.bill.id).then(() =>{
      this.showNotification(
          "Email enviado",
          SpotlightTextColor.Primary,
        );
    })
  }

  private generateUrlChangeData() {
    // var changeDataUrl = (window.location.href + '/' + this.currentPurchase.bill.id).replace('/app/', '/public/');
    var changeDataUrl = window.location.href.split("#")[0] + "#/public/billing/" + this.purchase.bill.id

    navigator.clipboard.writeText(changeDataUrl)
      .then(() => {
        // this.emitMessageError({ 'data': { 'detail': "Enlace copiado al portapapeles" } });

        this.showNotification(
          "Enlace copiado",
          SpotlightTextColor.Primary,
        );

      })
      .catch(err => {
        console.error('Error al copiar el enlace:', err);
      });
  }

  private created() {
    this.initializeComponent();
  }

  get convocationList() {
    let list = this.saleInfoList;
    if (this.showConvocation) {
      list = [this.convocation];
    }
    return list;
  }

  get convocation() {
    return this.getConvocation(this.convocationId);
  }

  get hasError() {
    return this.error !== "";
  }

  get convocationDefault() {
    return this.convocationOptions.find((convocation: any) => {
      // return convocation.id === this.saleInfoList[0].id;
      return convocation.id === this.saleInfoDefault.id;
    });
  }

  private fetchSaleInfo(
    callback = () => {
      const doNothing = 1;
    }
  ) {
    this.$store.dispatch("fetchSaleInfo", { id: this.convocationId }).then(
      res => {
        callback();
      },
      err => {
        this.checkResponseError(err);
      }
    );
  }

  private fetchConvocation(
    callback = () => {
      const doNothing = 1;
    }
  ) {
    if (this.convocationId)
      this.$store.dispatch("fetchConvocation", { id: this.convocationId }).then(
        res => {
          callback();
        },
        err => {
          this.checkResponseError(err);
        }
      );
  }

  private checkResponseError(err: any) {
    if (err.response.status === 404) {
      this.error = err.response.data && err.response.data.detail;
    } else if (err.response.status === 500) {
      this.error = Constans.internalServerErrorMessage;
    }
  }

  private setGroupButtonConvocationOptions() {
    this.saleInfoList.forEach(saleInfo => {
      const option = {
        id: saleInfo.id,
        text: (saleInfo.product as any).name
      };
      this.convocationOptions.push(option);
    });
    this.convocationOptionSelected = this.convocationDefault.id;
  }

  private isConvocationActive(saleInfo: SaleInfo) {
    return (
      (saleInfo.product as any).id ===
      (this.convocationSelected.product as any).id
    );
  }

  private setConvocationSelected(saleInfo: SaleInfo) {
    this.convocationSelected = saleInfo;
    this.$emit(
      "product-selected",
      this.convocationSelected.product,
      this.convocationSelected.id
    );
  }

  private saleInfoCallback() {
    if (this.saleInfoList) {
      // this.setConvocationSelected(this.saleInfoList[0]);
      this.setConvocationSelected(this.saleInfoDefault);
      this.setGroupButtonConvocationOptions();
      this.convocationInfoLoaded = true;
    }
  }

  private convocationCallback() {
    if (this.convocation) {
      this.setConvocationSelected(this.convocation);
      this.convocationInfoLoaded = true;
    }
  }

  private initializeComponent() {
    if (this.showConvocation) {
      this.fetchConvocation(() => {
        this.convocationCallback();
      });
    } else {
      this.fetchConvocation()
      this.fetchSaleInfo(() => {
        this.saleInfoCallback();
      });
    }
  }
}
